"use client";

import type { AlbumMusicPlayerBlock } from "@mw/shared/payload-types";
import dynamic from "next/dynamic";
import { NativeAudioProvider } from "@/app/_providers/native-audio/NativeAudioProvider";

const BlockAlbumMusicPlayer = dynamic(() => import("./BlockAlbumMusicPlayer").then(mod => mod.BlockAlbumMusicPlayer));

export const BlockAlbumMusicPlayerWrapper = (props: AlbumMusicPlayerBlock) => {
  return (
    <NativeAudioProvider>
      <BlockAlbumMusicPlayer {...props} />
    </NativeAudioProvider>
  );
};
